import type { ReactNode } from "react"

import type { SX } from "../../theme"
import { Text } from "../Text"
import styles from "./UnorderedList.module.css"

export interface UnorderedListProps {
  children?: ReactNode
  sx?: SX
}

export function UnorderedList(props: UnorderedListProps) {
  const { children, sx } = props
  return (
    <ul className={styles.list} style={sx}>
      {children}
    </ul>
  )
}

export interface ListItemProps {
  children?: ReactNode
}

export function ListItem(props: ListItemProps) {
  const { children } = props

  return (
    <li className={styles.item}>
      <Text component="span">{children}</Text>
    </li>
  )
}
